import React, { useContext } from 'react'
import { Outlet } from 'react-router-dom'

import TopBar from '@msteams/components/TopBar'
import GlobalContext from '@msteams/GlobalContext'
import NoConsentGrantedBanner from '@msteams/components/NoConsentGrantedBanner'

import { AppScope } from '@msteams/types/common'

const AppLayout = () => {
  const { scope } = useContext(GlobalContext)

  return (
    <>
      <NoConsentGrantedBanner />
      {scope === AppScope.personal && <TopBar />}
      <div className="px-3 py-4 flex-1 min-h-0 overflow-auto">
        <Outlet />
      </div>
    </>
  )
}
export default AppLayout
